import CloseIcon from "@mui/icons-material/Close";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import { termsAndConditionsContent } from "../assets/termsAndConditionsContent";

export const TermsAndConditions = ({ openInNewPage = false, setOpenTermsAndConditions = () => {} }) => {
  return (
    <>
      {!openInNewPage ? (
        <IconButton style={{ position: "absolute", top: "2px", right: "5px", zIndex: 1 }} onClick={() => setOpenTermsAndConditions()}>
          {/* <CloseIcon /> */}
        </IconButton>
      ) : (
        <></>
      )}
      <Box sx={{ p: openInNewPage ? "0px 50px" : "50px" }}>
        <ReactMarkdown>{termsAndConditionsContent}</ReactMarkdown>
      </Box>
    </>
  );
};
